import { render } from "./Craft.vue?vue&type=template&id=2bca4ced&scoped=true"
import script from "./Craft.vue?vue&type=script&lang=js"
export * from "./Craft.vue?vue&type=script&lang=js"

import "./Craft.vue?vue&type=style&index=0&id=2bca4ced&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bca4ced"]])

export default __exports__